import React from 'react';
import { Grid, Box, useTheme, useMediaQuery } from '@mui/material';

import { dateToLocalString } from '@shared/helpers/flights/reserve';
import FlightTextItem from './FlightTextItem';

const FlightSegment = ({ icon: Icon, date, airport }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xl'));

  const iconSize = isMobile
    ? { width: 18, height: 12 }
    : { width: 28, height: 19 };

  return (
    <Grid container alignItems="center" sx={{ mt: '1vh' }}>
      <Grid item xs={2}>
        <Box>{React.cloneElement(Icon, iconSize)}</Box>
      </Grid>
      <Grid item xs={10}>
        <FlightTextItem xs={12} sxItem={{ textAlign: 'left' }}>
          {dateToLocalString(date)}
        </FlightTextItem>
        <FlightTextItem xs={12} sxItem={{ textAlign: 'left', fontWeight: 400 }}>
          {airport}
        </FlightTextItem>
      </Grid>
    </Grid>
  );
};

export default FlightSegment;
